import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { LoadingState } from '@/components/feedback/LoadingState'
import { RequirePermission } from '@/lib/auth'
import { featureRegistry as defaultRegistry, type FeatureRegistry } from './features/registry'
import { AppLayout } from './layout/AppLayout'
import { DEFAULT_ROUTE, flattenNavigation, ROUTES } from './navigation'
import { AuthCallbackPage } from './pages/AuthCallbackPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { UnderConstructionPage } from './pages/UnderConstructionPage'

/** Rotas antigas do legado que têm equivalente no v2 (links salvos continuam funcionando). */
const LEGACY_REDIRECTS: Record<string, string> = {
  '/dashboard': DEFAULT_ROUTE,
  // Drill-down legado (desligado/quebrado no legado): leva para a lista.
  '/operational/schedules/requests/companies': ROUTES.scheduleRequests,
  '/operational/schedules/requests/company/sellers': ROUTES.scheduleRequests,
  '/metabase/dashboards/list': ROUTES.metabaseDashboards,
  '/metabase/indicators/list': ROUTES.metabaseIndicators,
}

export function AppRoutes({ registry = defaultRegistry }: { registry?: FeatureRegistry }) {
  // Itens de menu (DEC-006) cuja feature ainda não foi registrada → "Em construção".
  const placeholders = flattenNavigation().filter(({ leaf }) => !registry.has(leaf.featureId))

  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route element={<AppLayout />}>
        <Route index element={<Navigate to={DEFAULT_ROUTE} replace />} />
        {registry.routes.map((route) => (
          <Route
            key={`${route.featureId}:${route.path}`}
            path={route.path}
            element={
              <RequirePermission permission={route.permission}>
                <Suspense fallback={<LoadingState label="Carregando página…" />}>
                  <route.Component />
                </Suspense>
              </RequirePermission>
            }
          />
        ))}
        {placeholders.map(({ leaf }) => (
          <Route
            key={`placeholder:${leaf.id}`}
            path={`${leaf.to}/*`}
            element={
              <RequirePermission permission={leaf.permission}>
                <UnderConstructionPage />
              </RequirePermission>
            }
          />
        ))}
        {Object.entries(LEGACY_REDIRECTS).map(([from, to]) => (
          <Route key={from} path={from} element={<Navigate to={to} replace />} />
        ))}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
